import { z } from 'zod'

const TIP_MIN_AMOUNT = 0
const TIP_MAX_AMOUNT = 250
const TIP_STEP = 0.01

export const amountSchema = z.object({
  amount: z.coerce
    .number({
      invalid_type_error: 'Please enter a valid amount',
    })
    .gt(TIP_MIN_AMOUNT, { message: 'Please enter a valid amount' })
    .lte(TIP_MAX_AMOUNT, {
      message: `The total amount cannot be greater than $${TIP_MAX_AMOUNT}`,
    })
    .step(TIP_STEP, {
      message: `The total amount must be in increments of $${TIP_STEP}`,
    }),
})

const workIdSchema = z.object({
  workId: z.coerce.number().gt(0, { message: 'Please enter a valid work ID' }),
})

export const tipsSchema = z.object({
  // Drop empty/zero rows first so leaving some workers untipped is valid, but at least one valid tip is required.
  tips: z.preprocess((tips) => {
    if (!Array.isArray(tips)) {
      return tips
    }
    return tips.filter((tip) => Boolean(tip?.amount))
  }, z.array(workIdSchema.and(amountSchema)).min(1, { message: 'Please enter a tip' })),
})
